import WinningAnnouncement from './WinningAnnouncement';
export default WinningAnnouncement;
